import React from 'react';
import { observer } from "mobx-react-lite";
import ChatBox from "../../../../../elements/ChatBox/ChatBox";

const ChatComponent = observer(({ store }) => {
    
    return (
        <ChatBox
            customerSelected={store.account}
            agentId={store.id}
            agentDomain={false}
            inputWidth="80vh"
            agentData={{
                ...store.agentSelected,
                actions: store.actions,
                placeholderInput: store.agentSelected?.placeholderInput || "Ask anything..."
            }}
            showNewChatButton={true}
            metadata={{}}
            initialMessage={null}
        />
    );
});

export default ChatComponent;
